import { render, staticRenderFns } from "./IRContactUsPage.vue?vue&type=template&id=739920c7"
import script from "./IRContactUsPage.vue?vue&type=script&lang=js"
export * from "./IRContactUsPage.vue?vue&type=script&lang=js"
import style0 from "./IRContactUsPage.vue?vue&type=style&index=0&id=739920c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports